var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[_c('img',{staticClass:"no-data__image",attrs:{"alt":"no data","src":require("@/assets/images/no-data.svg")}}),_c('p',{staticClass:"no-data__description",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }